import React, { useState } from 'react';
import { MarketplaceHeader } from '../components/layout/MarketplaceHeader';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from '../components/marketplace/HeroSection';
import { CategoryChips } from '../components/marketplace/CategoryChips';
import { RestaurantCard } from '../components/marketplace/RestaurantCard';
import { useMarketplaceData } from '../lib/hooks';
import { Skeleton } from '../components/ui/Skeleton';
import { EmptyState } from '../components/ui/EmptyState';
import { Store } from 'lucide-react';
export function HomePage() {
  const {
    categories,
    featuredRestaurants,
    allRestaurants,
    zones,
    loading
  } = useMarketplaceData();
  const [activeCategory, setActiveCategory] = useState<string>('');
  return <div className="min-h-screen flex flex-col bg-brand-offwhite" data-id="element-1009">
      <MarketplaceHeader data-id="element-1010" />

      <main className="flex-1" data-id="element-1011">
        <HeroSection data-id="element-1012" />

        <div className="max-w-7xl mx-auto py-8" data-id="element-1013">
          {/* Categories */}
          {loading ? <div className="px-4 sm:px-6 lg:px-8 mb-12 flex gap-4 overflow-x-auto" data-id="element-1014">
              {[1, 2, 3, 4, 5, 6].map(i => <Skeleton key={i} className="h-12 w-32 rounded-full shrink-0" data-id="element-1015" />)}
            </div> : <div className="mb-12" data-id="element-1016">
              <CategoryChips categories={categories} activeCategory={activeCategory} onSelect={setActiveCategory} data-id="element-1017" />
            </div>}

          {/* Featured Section */}
          <section className="px-4 sm:px-6 lg:px-8 mb-16" data-id="element-1018">
            <div className="flex items-center justify-between mb-8" data-id="element-1019">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-1020">
                Restaurantes Destacados
              </h2>
            </div>

            {loading ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1021">
                {[1, 2, 3].map(i => <Skeleton key={i} variant="card" className="h-[320px]" data-id="element-1022" />)}
              </div> : featuredRestaurants.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1023">
                {featuredRestaurants.map(restaurant => <RestaurantCard key={restaurant.id} restaurant={restaurant} zoneName={zones.find(z => z.id === restaurant.zone_id)?.name} data-id="element-1024" />)}
              </div> : <EmptyState icon={Store} title="No hay restaurantes destacados" description="Vuelve pronto para descubrir nuevas opciones en tu zona." data-id="element-1025" />}
          </section>

          {/* All Restaurants Section */}
          <section className="px-4 sm:px-6 lg:px-8 mb-16" data-id="element-1026">
            <div className="flex items-center justify-between mb-8" data-id="element-1027">
              <div data-id="element-1028">
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-1029">
                  Todos los Restaurantes
                </h2>
                <p className="text-sm text-gray-500 mt-1" data-id="element-1030">
                  Cada restaurante gestiona sus pedidos directamente
                </p>
              </div>
            </div>

            {loading ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1031">
                {[1, 2, 3, 4, 5, 6].map(i => <Skeleton key={i} variant="card" className="h-[320px]" data-id="element-1032" />)}
              </div> : allRestaurants.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1033">
                {allRestaurants.map(restaurant => <RestaurantCard key={restaurant.id} restaurant={restaurant} zoneName={zones.find(z => z.id === restaurant.zone_id)?.name} data-id="element-1034" />)}
              </div> : <EmptyState icon={Store} title="No se encontraron restaurantes" description="Aún no hay restaurantes disponibles. Vuelve pronto." data-id="element-1035" />}
          </section>
        </div>
      </main>

      <Footer data-id="element-1036" />
    </div>;
}